module.exports = "img/flags/MA.8dec967.png";